import { render, staticRenderFns } from "./VsHead.vue?vue&type=template&id=0e3c2173&scoped=true&"
import script from "./VsHead.vue?vue&type=script&lang=js&"
export * from "./VsHead.vue?vue&type=script&lang=js&"
import style0 from "./VsHead.vue?vue&type=style&index=0&id=0e3c2173&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e3c2173",
  null
  
)

export default component.exports